/* unplugin-vue-components disabled */import script from "./BatchPointsImport.vue?vue&type=script&setup=true&lang=js"
export * from "./BatchPointsImport.vue?vue&type=script&setup=true&lang=js"

import "./BatchPointsImport.vue?vue&type=style&index=0&id=1afba1fb&lang=scss&scoped=true"

import exportComponent from "/Users/fubeibei/TRAE_workspace/cuiwei_xcxsc/cw/travel-manage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1afba1fb"]])

export default __exports__